import React from 'react';

import HotelMapLoader from 'src/components/YandexMap/components/HotelMapLoader';
import type { LazyYandexMapsCheckoutProps } from './types';
import styles from './lazyYandexMapsCheckout.module.css';

const YandexHotelMap = React.lazy(
  () =>
    import(/* webpackChunkName: "YandexMapCheckout" */ './YandexMapsCheckout'),
);

const LazyYandexMapsCheckout: React.FC<
  Readonly<LazyYandexMapsCheckoutProps>
> = (props) => {
  const [isMapLoading, setIsMapLoading] = React.useState(true);

  return (
    <div className={styles.container}>
      {isMapLoading && <HotelMapLoader />}
      <YandexHotelMap setIsMapLoading={setIsMapLoading} {...props} />
    </div>
  );
};

export default LazyYandexMapsCheckout;
